import { USER_STATUS } from "../constants/user";
import { Branch } from "./branch";
import { Locale } from "./translations";

type RegisterUserType = {
  email: string;
  firstName: string;
  lastName: string;
  telephone: string;
  password: string;
};
type LoginUserType = {
  telephone: string;
  password: string;
};
type ForgotPasswordType = {
  telephone: string;
};
type UserStatusType = (typeof USER_STATUS)[keyof typeof USER_STATUS];
type Verification = {
  telephone: string;
  attempts: number;
  remainingAttempts: number;
};
type AuthenticatedUserType = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  telephone: string;
  rememberToken: string;
  preferredLocale: Locale;
  isVerified: boolean;
  isIncomplete: boolean;
  status: UserStatusType;
  verification: Verification;
  tposBranch: Branch;
};
type UpdateUserType = {
  id: string | number;
  email: string;
  firstName: string;
  lastName: string;
  telephone: string;
  preferredLocale: string;
};
type RegisterFormType = {
  email: string;
  firstName: string;
  lastName: string;
  countryCallingCode: string;
  telephone: string;
  telephoneField: string;
  password: string;
};

type UserPersonalInfo = {
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
};

type UserProfile = UserPersonalInfo & {
  preferredLocale: Locale;
};

export type {
  RegisterUserType,
  RegisterFormType,
  LoginUserType,
  ForgotPasswordType,
  AuthenticatedUserType,
  UpdateUserType,
  UserProfile,
  Verification,
};
